<div class="card included-apps-group" [class.expanded]="expanded" [class.selected]="selected"
     [class.without-flows]="flowsStatus != 'flows'">
  <div class="card-header">
    <div class="header-row">
      <button type="button" class="toggle" (mousedown)="$event.stopPropagation()" (click)="toggle($event)"
              [title]="expanded ? 'Fold ' + appGroup.name + ' into one box' : 'Unfold ' + appGroup.name + ': show its sub-groups and members'"
              [attr.aria-expanded]="expanded">
        {{ expanded ? '▾' : '▸' }}
      </button>
      <span class="name">{{ appGroup.name }}</span>
      @if (appGroup.inclusion?.file) {
        <cds-icon shape="cog" class="settings" (mousedown)="$event.stopPropagation()" (click)="showSettings($event)"
                  [title]="'Settings of ' + appGroup.name + ' (' + appGroup.inclusion.file + ')'"></cds-icon>
      }
    </div>
    @if (!expanded) {
      <div class="count">{{ foldedSummary }}</div>
    }
    @if (flowsStatus == 'silent') {
      <div class="flows-status" title="No flow between the members of this group and the other groups over the selected period">
        No flows
      </div>
    } @else if (flowsStatus == 'empty') {
      <div class="flows-status warning" title="This group has no member yet">
        <cds-icon shape="exclamation-triangle"></cds-icon> No members
      </div>
    }
  </div>
</div>
